
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDuctEndPoint as ObiDuctEndPointElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-duct-end-point.js';
 
 
 

 
 export const ObiDuctEndPoint = createComponent({
   react: React,
   tagName: 'obi-duct-end-point',
   elementClass: ObiDuctEndPointElement,
   events: {
     
   }
  });
 
 